import { render } from "./ScreenSlide.vue?vue&type=template&id=4fe9185e&scoped=true&ts=true"
import script from "./ScreenSlide.vue?vue&type=script&lang=ts"
export * from "./ScreenSlide.vue?vue&type=script&lang=ts"

import "./ScreenSlide.vue?vue&type=style&index=0&id=4fe9185e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe9185e"]])

export default __exports__